import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { Organization, OrganizationDefaultValues } from 'src/app/components/organization/org';
import { OrganizationService } from 'src/app/services/organization.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-add-org',
    templateUrl: './add-org.component.html',
    styleUrls: ['./add-org.component.scss'],
    standalone: false
})
export class AddOrgComponent {

  org=OrganizationDefaultValues();
  isSubmitted=false;
  pageName = CheckPageAccess.ORGMANAGEMENT

  constructor(private _orgservice:OrganizationService,private router:Router,private _toastservice:ToastService) { }
  
  onSubmit()
  {
    this.isSubmitted=true;
    this._orgservice.createOrg(this.org).subscribe({
      next:(data)=>{
        if(data)
        {
        this._toastservice.showMessage("Organization Added Successfully")
        this.router.navigateByUrl('org-list')
        }
        else
        {
          this._toastservice.showMessage("This Organization Already Exists")
        }
      }
    })
  }
}
